import { HomeView } from '@features/home'
import { SERVICE_NAME } from '@shared/constants/service'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  component: HomePage,
  head: () => ({
    meta: [
      { title: `${SERVICE_NAME} — 사주 명리학으로 읽는 나만의 인생 해석서` },
      {
        name: 'description',
        content:
          '정통 명리학 기반 사주팔자 분석. 오행 차트, 월별 운세, 맞춤 조언까지. 3분이면 충분해요.',
      },
    ],
  }),
})

function HomePage() {
  return <HomeView />
}
